var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResumeDarkBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 639,
    viewBox: "0 0 311 639",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304 6.99902H7V631.999H304V6.99902Z",
    fill: "#022539"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M307.5 3.49902H3.5V635.499H307.5V3.49902Z",
    stroke: "white",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeDarkBox);
export default __webpack_public_path__ + "static/media/resumeDarkBox.97a407294094cc5a258d69272d0c059d.svg";
export { ForwardRef as ReactComponent };